import { authFetch } from '../utils/authFetch';
import {baseUrl} from '../utils/requestUrl';
import { getActiveClinicalLocationId, getActiveOrganization } from '../utils/permissions';

export  const fetchPatients = async(pageNumber = 1, pageSize = 10) => {
    // The organization the user is working in, not whichever membership happens
    // to be first — those differ as soon as someone belongs to more than one.
    const organization = getActiveOrganization();

    const response = await authFetch(`${baseUrl}/organization/${organization?.id}/care-providers/${organization?.careProvider?.id}/patients?pageNumber=${pageNumber}&pageSize=${pageSize}`);

    return response.json();
}

export const fetchPatientsByClinicalLocation = async (pageNumber = 1, pageSize = 10) => {
    // Resolved against the active organization, not just the active role — see
    // getActiveClinicalLocationId.
    const clinicalLocationId = getActiveClinicalLocationId();

    const response = await authFetch(
        `${baseUrl}/careProviders/clinicalLocation/${clinicalLocationId}/patients?pageNumber=${pageNumber}&pageSize=${pageSize}`
    );
    const data = await response.json();

    // Normalize to match paginated format expected by the patient list page
    if (data?.data && Array.isArray(data.data)) {
        const all = data.data;
        const start = (pageNumber - 1) * pageSize;
        const paged = all.slice(start, start + pageSize);
        return {
            ...data,
            data: {
                content: paged,
                totalElements: all.length,
                totalPages: Math.ceil(all.length / pageSize),
            },
        };
    }

    return data;
};
export const fetchSinglePatient = async(patientId) => {
    // If no patientId provided, fall back to localStorage for backward compatibility
    const id = patientId || localStorage.getItem('patient')
    const response =  await authFetch(`${baseUrl}/patients/${id}`)
    return response.json()
   
}

export const admitPatient = async (patientId, admissionData) => {
    try {
        const response = await authFetch(`${baseUrl}/patients/${patientId}/admit`, {
            method: 'POST',
            body: JSON.stringify(admissionData),
        });
        return response.json();
    } catch (error) {
        throw error;
    }
};

export const fetchPatientCareProviders = async (patientId) => {
    // If no patientId provided, fall back to localStorage for backward compatibility
    const id = patientId || localStorage.getItem('patient');
    const response = await authFetch(`${baseUrl}/patients/${id}/care-providers`);
    return response.json();
};
